"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOGGLES = exports.ICON_NAME = exports.DEFAULT_LABEL = void 0;
var ICON_NAME = {
  SHIELD: 'ShieldTrustMarkLogo',
  JCB: 'JcbTrustMarkLogo',
  VISA: 'VisaTrustMarkLogo',
  PCI: 'PCITrustMarkLogo',
  MASTERCARD: 'MasterCardTrustMarkLogo'
};
exports.ICON_NAME = ICON_NAME;
var TOGGLES = {
  showJcb: true,
  showPci: true,
  showVisa: true,
  showMc: true
};
exports.TOGGLES = TOGGLES;
var DEFAULT_LABEL = '100% safe and secure payments powered by AirAsia';
exports.DEFAULT_LABEL = DEFAULT_LABEL;